<template>

    <div v-if="!activeUser.admin && activeUser.site && activeUser.site.hasDataProcessingConfirmed === false">

      <data-processing-modal></data-processing-modal>

    </div>

    <div v-else class="socialMedia">

      <!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <!-- page-heading -->
            <page-heading :show="true" pageTitle="SOCIAL_MEDIA-HEADLINE"></page-heading>

            <div class="columns">

                <div class="col-main">

                    <!-- OVERVIEW -->
                    <tabs v-if="userRole == 'Administrator'" type="boxed" size="normal">

                        <!-- tab: REDAKTIONSPLAN -->
                        <tab-item :label="$t('NEWSLETTER-TAB-EDITORIAL_PLAN')">

                            <!-- <h2>Apothekenkatalog {{ $store.getters.getCatalogName }}</h2> -->
                            <h2>Apothekenkatalog {{ currentCatalogName }}</h2>

                            <v-client-table ref="tblSocialMedia" name="tblSocialMedia" :data="newsletter.data" :columns="newsletter.columns" :options="newsletter.options" class="tbl-socialMedia noFirstColumn">

                                <!-- name -->
                                <template slot="name" slot-scope="props">
                                    <strong>{{ props.row.name }}</strong>
                                </template>

                                <template slot="scheduleDate" slot-scope="props">
                                    <strong>{{ formatDate2(props.row.scheduleDate, false) }}</strong>
                                </template>

                                <!-- options -->
                                <template slot="edit" slot-scope="props">

                                    <span class="icon is-small" @click.stop="postEdit(props.row)" title="Eintrag bearbeiten">
                                        <i class="icon-ak-bearbeiten"></i>
                                    </span>

                                    <pop-confirm class="icon is-small" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" :on-ok="function() { postDelete(props.row.id) }" cancel-text="nein" title="Beitrag löschen">
                                        <i class="icon-ak-entfernen"></i>
                                    </pop-confirm>

                                </template>


                                <template slot="child_row" slot-scope="props">

                                    <div class="columns articles" v-if="props.row.catalogPageElement != null">

                                        <div class="column is-narrow">
                                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + props.row.catalogPageElement.image"></div>
                                        </div>

                                        <div class="column">
                                            <div class="preview">
                                                <span class="headline">{{ props.row.catalogPageElement.headline }}</span>
                                                <div v-html="getExcerpt(props.row.catalogPageElement)"></div>
                                            </div>
                                        </div>

                                        <div class="column is-narrow">
                                            <pop-confirm class="icon is-small has-pointer" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { articleRemove(props.row.id) }">
                                                <i class="fa icon-ak-entfernen"></i>
                                            </pop-confirm>
                                        </div>

                                    </div>

                                    <div v-else class="columns articles">
                                        <div class="column is-narrow">
                                            <div class="imgWrapper plain has-pointer" @click="articlesLoad(props.row.id)">
                                                <span class="icon"><i class="icon-ak-hinzufuegen"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                </template>

                            </v-client-table>


                            <div class="tabButtons">
                                <!--
                                <custom-button name="NEWSLETTER-BTN-PRINT" type="dark" size="small" icon="icon-ak-print"></custom-button>
                                <custom-button name="NEWSLETTER-BTN-EXPORT" type="dark" size="small" icon="icon-ak-export"></custom-button>
                                -->
                                <custom-button name="NEWSLETTER-BTN-ADD" type="blue" size="small" icon="icon-ak-hinzufuegen" @click.native="postAdd"></custom-button>
                            </div>

                        </tab-item>


                        <!-- tab: APOTHEKEN -->
                        <tab-item :label="$t('NEWSLETTER-TAB-PHARMACIES')">

                            <h2>Apothekenkatalog {{ currentCatalogName }}</h2>

                            <v-client-table ref="tblSocialMediaPharmacies" name="tblSocialMediaPharmacies" :data="newsletterPharmacies.data" :columns="newsletterPharmacies.columns" :options="newsletterPharmacies.options" class="tbl-socialMediaPharmacies noFirstColumn">

                                <!-- before table: FILTER OPTIONS -->
                                <template slot="beforeTable">

                                    <div class="columns is-marginless is-pulled-right filters">

                                        <!-- filter  newsletter -->
                                        <div class="column">
                                            <form-input inputType="select" label="NEWSLETTER-PHARMACIES-FILTER_NEWSLETTER_NAME" v-model="filterPharmaciesNewsletterName" :selectAllowEmpty="false" :selectOptions="postSelectOptions" :showLabel="false" :showLabelInOptions="false" class="is-pulled-right"></form-input>
                                        </div>

                                        <!-- filter  newsletter sent -->
                                        <div class="column">
                                            <form-input inputType="select" label="NEWSLETTER-PHARMACIES-FILTER_NEWSLETTER_SENT" :selectAllowEmpty="false" v-model="filterPharmaciesNewsletterSent" :selectOptions="filterPharmaciesNewsletterSentOptions" :showLabel="false" :showLabelInOptions="false" class="is-pulled-right"></form-input>
                                        </div>

                                    </div>

                                </template>

                                <template slot="h__select">
                                  <p-check name="check" color="primary" class="p-default p-curve p-smooth" v-model="pharmaciesMarkedAll" @click.prevent.native="pharmaciesToggleAll()"></p-check>
                                </template>

                                <!-- checkbox -->
                                <template slot="select" slot-scope="props">
                              		<div class="checkboxWrapper">
                                    <p-check name="check" color="primary" :value="props.row.id" v-model="pharmaciesMarkedRows" class="p-default p-curve p-smooth"></p-check>
                                  </div>
                        	      </template>

                                <template slot="date" slot-scope="props">

                                  <template v-if="props.row.socialMediaPosts.length > 0 && props.row.socialMediaPosts.find((post) => post.socialMediaPost != null && post.socialMediaPost == filterPharmaciesNewsletterName.id)">

                                      <template v-for="(post, index) in props.row.socialMediaPosts">

                                        <div v-if="post.socialMediaPost == filterPharmaciesNewsletterName.id">
                                          {{ formatDate2(post.publishDate, false) }}
                                        </div>

                                        <!--
                                        <template v-else>
                                            <template v-if="index == 0">
                                                -
                                            </template>
                                        </template>
                                        -->

                                      </template>

                                  </template>

                                  <template v-else>
                                      -
                                  </template>

                                </template>

                                <!-- bulk action -->
                                <template slot="afterTable">

                                    <span :class="['button is-light', { 'is-disabled': pharmaciesMarkedRows.length == 0 }]" @click="reminderOpen">
                                        <span class="icon is-small"><i class="icon-ak-reminder"></i></span>Reminder versenden
                                    </span>

                                </template>

                            </v-client-table>


                            <div class="tabButtons">

                                <!--
                                <custom-button name="NEWSLETTER-BTN-PRINT" type="dark" size="small" icon="icon-ak-print"></custom-button>
                                <custom-button name="NEWSLETTER-BTN-EXPORT" type="dark" size="small" icon="icon-ak-export"></custom-button>
                                -->


                            </div>

                            <!--
                            <div class="tabButtons">

                                <custom-button name="CPC-VARIANT-CHANGELOG" type="dark" size="small" icon="icon-ak-history" :class="{ 'is-disabled': !activeUser.isAdminRole && variant.id == null}"></custom-button>
                                <custom-button name="CPC-VARIANT-EXPORT" type="dark" size="small" icon="icon-ak-export" :class="{ 'is-disabled': !activeUser.isAdminRole && variant.id == null }"></custom-button>

                            </div>
                            -->

                        </tab-item>


                        <!-- tab: LOGS -->
                        <!--
                        <tab-item :label="$t('NEWSLETTER-TAB-LOGS')">


                        </tab-item>
                        -->

                    </tabs>


                    <!-- SITE NEWSLETTER -->
                    <tabs v-else type="boxed" size="normal">

                        <tab-item :label="$t('SOCIAL_MEDIA-PHARMACY-TAB-EDITORIAL_PLAN')">

                            <div class="newsletterHeader is-clearfix" style="padding-bottom: 10px; margin-bottom: 15px; border-bottom: 1px solid #eee;">

                                <div class="is-pulled-left">
                                    <h2>Apothekenkatalog  {{ currentCatalogName }}</h2>
                                    <form-input inputType="select" label="SOCIAL_MEDIA-PHARMACIES-FILTER_NEWSLETTER_NAME" v-model="changedPost" :selectOptions="sitePostsSelectOptions" :selectAllowEmpty="false" :showLabel="true" :showLabelInOptions="false"></form-input>
                                    <span v-if="selectedPost" class="scheduleDate">empfohlene Veröffentlichung {{ formatDate2(selectedPost.scheduleDate, false) }}</span>
                                </div>

                            </div>

                            <template v-if="selectedPost">

                                <div class="centered is-clearfix">

                                    <div class="columns newsletterArticle" v-if="selectedPost.catalogPageElement != null">

                                        <div class="column is-narrow">
                                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + selectedPost.catalogPageElement.image" :key="changedPost"></div>
                                        </div>

                                        <div class="column preview">
                                            <span class="headline">{{ selectedPost.catalogPageElement.headline }}</span>
                                            <div v-html="getExcerpt(selectedPost.catalogPageElement)"></div>
                                        </div>

                                        <div class="column is-narrow">
                                            <pop-confirm :class="['icon is-small has-pointer delArticle', {'is-disabled': !isEnabeld}]" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { sitePostArticleRemove() }">
                                                <i class="fa icon-ak-entfernen"></i>
                                            </pop-confirm>
                                        </div>

                                    </div>

                                    <div v-else class="columns newsletterArticle">
                                        <div class="column is-narrow">
                                            <div :class="['imgWrapper plain has-pointer', { 'is-disabled': !isEnabeld}]" @click="sitePostArticlesLoad">
                                                <span class="icon"><i class="icon-ak-hinzufuegen"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- 'is-disabled': selectedPost.publishDate != null,  -->
                                <div class="has-text-centered" style="margin-top: 25px;">
                                    <custom-button type="blue" :name="selectedPost.publishDate == null ? 'SOCIAL_MEDIA-PHARMACY-BTN-POST' : 'SOCIAL_MEDIA-PHARAMCY-BTN-RENEW'" icon="icon-ak-speichern" @click.native="sitePostPublish()" :class="{ 'is-loading': isSaving }">
                                      <small v-if="selectedPost.publishDate != null">zuletzt: {{ formatDate2(selectedPost.publishDate) }}</small>
                                    </custom-button>
                                </div>

                                <!--
                                <pre>
                                    {{ selectedPost }}
                                </pre>
                                -->

                            </template>

                        </tab-item>

                    </tabs>



                    <!-- MODAL -->
                    <modal
                        :width="modal.width"
                        :title="modal.title"
                        transition="fadeDown"
                        cancel-text="Abbrechen"
                        :show-ok="false"
                        :backdrop-closable="false"
                        :is-show="showModal"
                        :class="['vcenter', modal.class]"
                        @close="closeModal">

                            <template v-if="modal.isLoading">
                                <loading-indicator></loading-indicator>
                            </template>

                            <template v-else>

                                <!-- SELECT ARTICLES -->
                                <template v-if="['articles', 'sitePosts'].indexOf(modal.type) > -1">

                                    <v-client-table ref="tblSocialMediaArticles" name="tblSocialMediaArticles" :data="articles.data" :columns="articles.columns" :options="articles.options" class="noFirstColumn">

                                        <!-- before table: FILTER OPTIONS -->
                                        <template slot="beforeTable">

                                            <!-- SEARCH -->
                                            <form class="control has-addons is-pulled-left" @submit.prevent="articleSearch" style="margin-right: 7px;">

                                                <input class="input" type="text" ref="checkboxSelector" v-model="articleSearchString" placeholder="Suchbegriff">

                                                <span class="button is-info" @click="articleSearch">
                                                    <span class="icon is-small"><i class="fa fa-search"></i></span>
                                                </span>

                                            </form>

                                        </template>

                                        <!-- checkbox -->
                                        <template slot="select" slot-scope="props">
                                            <div class="checkboxWrapper">
                                                <p-check name="check" color="primary" :value="props.row.id" v-model="markedRows" class="p-default p-curve p-smooth"></p-check>
                                            </div>
                                        </template>

                                        <!-- image -->
                                        <template slot="asset" slot-scope="props">
                                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets +  props.row.image" :key="props.row.id"></div>
                                        </template>

                                        <!-- name -->
                                        <template slot="name" slot-scope="props">
                                            {{ props.row.headline }}
                                        </template>

                                    </v-client-table>

                                    <div slot="footer">
                                        <span class="button" @click="closeModal">schließen</span>

                                        <template v-if="modal.type == 'articles'">
                                            <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="articleAppend">übernehmen</span>
                                        </template>

                                        <template v-else>
                                            <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="siteArticleAppend">übernehmen</span>
                                        </template>
                                    </div>

                                </template>

                                <!-- NEWSLETTER ADD -->
                                <template v-else-if="modal.type == 'postAdd'">

                                    <form-input inputType="text" label="NEWSLETTER-EDIT-TITLE" v-model="tmpEntry.name" :isHorizontal="false"></form-input>

                                    <div class="control">
                    									<div class="control-label">
                    										<label-name labelKey="NEWSLETTER-EDIT-DISTRIBUTION_DATE"></label-name>
                    									</div>
                    									<div class="control">
                    										<datepicker placeholder="Datum wählen" :options="datePickerOptions" v-model="tmpEntry.scheduleDate"></datepicker>
                    									</div>
                    								</div>

                                    <div slot="footer">
                                        <span class="button" @click="closeModal">schließen</span>
                                        <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': tmpEntry.name == '' || tmpEntry.scheduleDate == null }]" @click="postAddOk">anlegen</span>
                                    </div>

                                </template>

                                <!-- NEWSLETTER EDIT -->
                                <template v-else-if="modal.type == 'postEdit'">

                                    <form-input inputType="text" label="NEWSLETTER-EDIT-TITLE" v-model="tmpEntry.name" :isHorizontal="false"></form-input>

                                    <div slot="footer">
                                        <span class="button" @click="closeModal">schließen</span>
                                        <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': tmpEntry.name == '' && tmpEntry.scheduleDate == null }]" @click="postEditOk">speichern</span>
                                    </div>

                                </template>


                                <!-- REMINDER -->
                                <template v-else-if="modal.type == 'reminder'">

                      							<div class="control froalaRTE froalaPlain">
                      								<froala id="froala" ref="froala" :tag="'textarea'" :config="froalaConfig" v-model="reminderText"></froala>
                      							</div>

                                    <div slot="footer">
                                        <span class="button" @click="closeModal">abbrechen</span>
                                        <span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="reminderSend">senden</span>
                                    </div>

                                </template>

                            </template>

                    </modal>

                </div>

            </div>

        </template>


    </div>
</template>


<script>
import Vue from 'vue';

import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import { de } from 'flatpickr/dist/l10n/de';

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import vue2Dropzone from '../utils/dropzoneWrapper';
import inputCounter from '../utils/inputCounter';

import exportButton from '../utils/exportButton'
import dataProcessingModal from '../utils/dataProcessingModal'

import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala);


import draggable from 'vuedraggable';

export default {

    components: {
        VueFroala,
        vueDropzone: vue2Dropzone,
        inputCounter,
        draggable,
        exportButton,
        dataProcessingModal
    },

    data() {

        var self = this;

        return {

            currentCatalogName: "",

            isLoading: false,
            isSaving: false,
            isSending: false,
            isSendingTest: false,
            showModal: false,

            refreshIntervalId: null,
            progressStatus: null,

            maxArticles: 1,
            articleSearchString: '',
            markedRows: [],
            activeRowId: null,
            activeRowIndex: null,

            pharmaciesMarkedAll: false,
            pharmaciesMarkedRows: [],

            siteNewsletter: {},
            siteNewsletters: [],
            siteNewsletterOptions: [],

            sitePost: {},
            sitePosts: [],
            sitePostsOptions: [],

            reminderText: '',

            selectedPostId: null,
            changedPost: null,

            filterPharmaciesNewsletterName: null,
            filterPharmaciesNewsletterSent: { id: 1, name: 'alle' },
            filterPharmaciesNewsletterSentOptions: [{ id: 1, name: "alle"}, { id: 2, name: 'versendet' }, { id: 3, name: 'nicht versendet' }],

            tmpEntry: {
                id: null,
                name: '',
                scheduleDate: null,
                articles: []
            },

            modal: {
                isLoading: false,
                isSaving: false,
                type: 'articles',
                title: '',
                width: '880',
                class: ''
            },

            datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
		            clickOpens: true,
                weekNumbers: true
            },

            // NEWSLETTER
            newsletter: {
                data: [],
                columns: ['name', 'scheduleDate', 'edit'],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 15,
                    orderBy: {
                        ascending: false,
                        column: 'scheduleDate'
                    },


                    // custom table headings
                    headings: {
                      name(h) {
                          return <lang labelKey="NEWSLETTER-TBL_HEADER-NAME"></lang>
                      },
                      scheduleDate(h) {
                          return <lang labelKey="NEWSLETTER-TBL_HEADER-DISTRIBUTION_DATE"></lang>
                      },
                      edit(h) {
                          return "";
                      },
                    },

                    columnsClasses: { 'edit': 'edit' },

                    sortable: ['name', 'scheduleDate'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [],
                }
            },

            // PHARMACIES
            newsletterPharmacies: {
                data: [],
                columns: ['select', 'date', 'extRef', 'name'],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings
                    headings: {
                      date(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-DATE"></lang>
                      },
                      extRef(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-ID"></lang>
                      },
                      name(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-NAME"></lang>
                      },
                      select(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-SELECT"></lang>
                      },
                    },

                    sortable: ['name', 'extRef'],
                    sortIcon: {
                      base:'fa',
                      up:'fa-sort-up',
                      down:'fa-sort-down',
                      is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                      filter: 'Filter Ergebnisse:',
                      filterPlaceholder: 'Suche',
                      limit: 'Einträge pro Seite',
                      noResults: 'keine passenden Einträge gefunden',
                      count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [

                      {
                        name: 'search',
            						callback(row, string) {
            							if(string == null || string == "") {
            								return true;
            							}
            							string = string.toLowerCase();
            							return row.catalogPage.name.toLowerCase().indexOf(string) > -1;
            						}
                      },

                      {
                        name: 'filter',
  				              callback(row, payload) {


                          let sentOption = payload.sentOption.name;

  			                  let socialMediaPostId = payload.newsletter == null ? null : payload.newsletter.id;
                          let isQualified = false;


                          if(sentOption != 'alle') {

                            if(sentOption == 'nicht versendet') {
                              isQualified = row.socialMediaPosts.length == 0 || row.socialMediaPosts.length > 0 && row.socialMediaPosts.findIndex((post) => post.socialMediaPost == socialMediaPostId) == -1;
                            }
                            else {
                              isQualified = row.socialMediaPosts.findIndex((post) => post.socialMediaPost == socialMediaPostId) > -1;
                            }

                          } else {

                            // all pharmacies should be displayed
                            isQualified = true;

                          }

                          return isQualified;

                          /*
                          // reset
                          if(postId == null && sentOption =='alle') {
                              return true;
                          }
                          var isQualified = false;

                          // sentOption only
                          if(postId == null && sentOption != 'alle') {

                              if(sentOption == 'nicht versendet') {
                                  isQualified = !row.socialMediaPosts.findIndex((n) => { n.publishDate == null }) > -1;
                              }
                              else {
                                  isQualified = row.socialMediaPosts.findIndex((n) => { n.publishDate != null }) > -1;
                              }

                          }

                          // post only
                          else if(sentOption == 'alle' && postId != null) {

                              for(var i in row.socialMediaPosts) {
                                  if(row.socialMediaPosts[i].id == postId) {
                                      isQualified = true;
                                      break;
                                  }
                              }
                          }

                          // sentOption and newsletter
                          else if (sentOption != 'alle' && postId != null) {

                              for(var i in row.socialMediaPosts) {

                                  if(sentOption == 'nicht versendet') {

                                      if(row.socialMediaPosts[i].publishDate == null && row.socialMediaPosts[i].id == postId) {
                                          isQualified = true;
                                          break;
                                      }

                                  } else {

                                      if(row.socialMediaPosts[i].publishDate != null && row.socialMediaPosts[i].id == postId) {
                                          isQualified = true;
                                          break;
                                      }

                                  }

                              }

                          }

                          return isQualified;
                          */


  						            }
                      }

                    ],

                    rowClassCallback(row) {
                        // return 'status ' + (row.publishDate != null ? 'SENT' : '');
                        return 'status' + (self.isSocialMediaPostSent(row.socialMediaPosts) ? ' SENT' : '');
                    }
                },


            },


            // ARTICLES
            articles: {
                data: [],
                columns: ['select', 'asset', 'name'],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 5,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings
                    headings: {

                        select(h) {
                            return "";
                        },
                        asset(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-ASSET"></lang>
                        },
                        name(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-NAME"></lang>
                        },

                    },

                    sortable: ['name'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [
                        {
                        name: 'search',
            						callback(row, string) {

            							if(string == null || string == "") {
            								return true;
            							}

            							string = string.toLowerCase();
            							return row.headline.toLowerCase().indexOf(string) > -1 || row.subheadline.toLowerCase().indexOf(string) > -1;
            						}
                        }

                    ],

                }
            },


            froalaConfig: {
              key: '',
	            // 'insertImage',
              toolbarButtons: ['bold', 'italic', 'underline', '|', 'insertLink', '|', 'subscript', 'superscript', '|', 'align', '|', 'undo', 'redo'],
              placeholderText: 'Schreiben Sie hier Ihren Text ...',
      				wordPasteModal: false,
      				pastePlain: true,
              initOnClick: false,
      				heightMin: 300,
      				heightMax: 500,
              // quickInsertButtons: ['table', 'ul', 'ol'],
              quickInsertButtons: [],
              quickInsertTags: [],
              language: 'de',
              tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
              tableMultipleStyles: false,
              tableResizer: true,
              charCounterCount: false,
	            // charCounterMax: 140,
              // quickInsertTags: [],        // disable quickInsertBar
            },

            appendedFormData: []
        }

    },

    computed: {

        mailTemplateTypes() {
            return this.$store.getters.getTermsByTaxonomy('MAIL_TEMPLATE_TYPES');
        },

        selectedPost() {

            var self = this;
            return this.sitePosts.find(post => post.id == self.selectedPostId );

        },

        isEnabeld() {

            return this.selectedPost.publishDate != null;
            // return new Date(this.selectedPost.scheduleDate) > new Date() || this.selectedPost.publishDate != null;

        },

        siteId() {

            return this.activeUser.site != null ? this.activeUser.site.id : 546;

        },

        postSelectOptions() {

            var selectOptions = [];

            var self = this;

            this.newsletter.data.forEach((newsletter) => {

                selectOptions.push({
                    id: newsletter.id,
                    scheduleDate: newsletter.scheduleDate,
                    name: self.formatDate2(newsletter.scheduleDate, false)
                })

            })

            selectOptions.sort(function(a, b) {
                return (a.publishDate < b.publishDate) ? -1 : ((a.publishDate > b.publishDDate) ? 1 : 0);
            });

            // make the first newsletter preselected ...
            this.filterPharmaciesNewsletterName = selectOptions[0];

            return selectOptions;

        },


        sitePostsSelectOptions() {

            var selectOptions = [];

            this.sitePosts.forEach((post) => {

                selectOptions.push({
                    id: post.id,
                    publishDate: post.publishDate,
                    name: post.label
                })

            })

            // sort by publishDate
            selectOptions.sort(function(a, b) {
                return (a.publishDate < b.publishDate) ? -1 : ((a.publishDate > b.publishDDate) ? 1 : 0);
            });

            return selectOptions;

        }

    },


    watch: {

        articleSearchString(newVal, oldVal) {

            if(newVal == oldVal) {
                return;
            }
            var self = this;

            setTimeout(function() {
                Event.$emit('vue-tables.tblSocialMediaArticles.filter::search', newVal );
            }, 10);

        },

        markedRows(newVal, oldVal) {

            if(this.markedRows.length > this.maxArticles) {
                this.$notify.open( { content: 'Sie können nur '+this.maxArticles+' Artikel auswählen', type: 'warning' })
            }

        },

        pharmaciesMarkedRows(newVal, oldVal) {

            if(this.pharmaciesMarkedRows.length != this.newsletterPharmacies.data.length) {
                this.pharmaciesMarkedAll = false;
            }

        },

        changedPost(newVal, oldVal) {

            this.selectedPostId = newVal.id;

        },

        filterPharmaciesNewsletterSent(newVal, oldVal) {

            Event.$emit('vue-tables.tblSocialMediaPharmacies.filter::filter', {
                sentOption: newVal,
                newsletter: this.filterPharmaciesNewsletterName
            });

        },

        filterPharmaciesNewsletterName(newVal, oldVal) {

            Event.$emit('vue-tables.tblSocialMediaPharmacies.filter::filter', {
                sentOption: this.filterPharmaciesNewsletterSent,
                newsletter: newVal
            });

        }
    },

    created() {

      // set licence key for froala
  		this.froalaConfig.key = this.$config.froalaKey;

      this.fetchData();
    },

    /*
    beforeRouteEnter (to, from, next) {

      next(vm => {
        // access to component public instance via `vm`
      })

      console.log("TO:", to);
      next(false);
    },
    */

    mounted() {

      this.initEventListeners();

    },

    beforeDestroy() {

      Event.$off('vue-tables.tblSocialMedia.row-click');

    },

    methods: {

      isSocialMediaPostSent(socialMediaPosts = []) {

          if(socialMediaPosts.length == 0) {
              return false;
          }

          var self = this;

          socialMediaPosts.some((socialMediaPost) => {
              if(socialMediaPost.id == self.filterPharmaciesNewsletterName.id && socialMediaPost.publishDate != null) {
                  return true;
              }
          })

      },


      getExcerpt(el, maxLength=280) {

          var str = "";

          if(el.subheadline != "") {

              str = el.subheadline;

          } else {

              let text = this.stripHTML(el.content);

              if(text.length > maxLength) {
                  text = text.substr(0, maxLength);
                  str = text.substr(0, Math.min(text.length, text.lastIndexOf(" "))) + ' ...'
              } else {
                  str = text;
              }

          }

          // console.log(el.friendlyName);
          return str + ' <a class="readmore" href="http://www.apothekenkatalog.at/'+el.friendlyName+'" target="_blank">weiterlesen</a>';

      },

      reminderOpen() {

          var templateID = this.mailTemplateTypes.NEWSLETTER_REMINDER.id;
          var self = this;

          this.modal.title = "Reminder versenden";
          this.modal.class = 'reminder';
          this.modal.type = 'reminder';
          this.modal.width = '720';
          this.showModal = true;
          this.modal.isLoading = true;

          this.axios.get(this.$config.api + 'mailTemplate?filters[type]='+templateID)
              .then((response) => {
                  self.reminderText = response.data.mailTemplate[0].body;
                  self.modal.isLoading = false;
              })
      },

      reminderSend() {

          this.modal.isSaving = true;
          var self = this;

          setTimeout(function() {

              self.closeModal();

              // todo: db send ...
              self.$notify.open({content: 'Reminder wurde erfolgreich versendet', type: 'success'});

          }, 1000);

      },

      pharmaciesToggleAll() {

          this.pharmaciesMarkedRows = this.pharmaciesMarkedAll ? [] : this.$refs.tblSocialMediaPharmacies.data.map(row => row.id);
          this.pharmaciesMarkedAll = !this.pharmaciesMarkedAll;

      },

      initEventListeners() {

          var self = this;

          Event.$on('vue-tables.tblSocialMedia.row-click', function(data) {
              self.$refs.tblSocialMedia.toggleChildRow(data.row.id);
          });

          Event.$on('vue-tables.tblSocialMediaPharmacies.row-click', function(data) {

              if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                  return false;
              }

              let foundIndex = self.pharmaciesMarkedRows.findIndex(function(row, index) { return row == data.row.id; });
              if(foundIndex > -1) {
                  self.pharmaciesMarkedRows.splice(foundIndex, 1);
              } else {
                  self.pharmaciesMarkedRows.push(data.row.id);
              }

          });
      },

      postAdd() {

          this.modal.title = 'Eintrag anlegen';
          this.modal.class = 'postAdd';
          this.modal.type = 'postAdd';
          this.modal.width = '480';
          this.modal.isLoading = false;
          this.showModal = true;

      },

      postEdit(row) {

          this.tmpEntry = JSON.parse(JSON.stringify(row));

          this.modal.title = "Eintrag bearbeiten";
          this.modal.class = 'postEdit';
          this.modal.type = 'postEdit';
          this.modal.width = '480';
          this.modal.isLoading = false;
          this.showModal = true;

      },

      postEditOk() {

          this.modal.isSaving = true;
          var self = this;

          this.entityCreateOrUpdate('socialMediaPost', this.tmpEntry)
              .then(function(response) {

                  var postIndex = self.newsletter.data.findIndex((p) => { return p.id == response.id });
                  self.$set(self.newsletter.data, postIndex, self.tmpEntry);

                  self.closeModal();

              })

      },

      postAddOk() {

          this.modal.isSaving = true;
          var self = this;

          this.tmpEntry.channel = 5;
          this.tmpEntry.catalogPageElement = null;

          this.entityCreateOrUpdate('socialMediaPost', this.tmpEntry)
              .then(function(response) {

                  self.newsletter.data.push(response);
                  self.closeModal();

              })

      },

      postDelete(postId) {

          var self = this;

          this.entityDelete('socialMediaPost', postId, false, true)
              .then(function(response) {

                  var postIndex = self.newsletter.data.findIndex((p) => { return p.id == postId });
                  self.newsletter.data.splice(postIndex, 1);
                  self.$notify.open({ content: 'Beitrag wurde erfolgreich entfernt!', type: 'success'});

              });

      },

      articleAppend() {

          var self = this;

          var post = this.newsletter.data.find((n) => { return n.id == this.activeRowId });
          post.catalogPageElement = this.articles.data.find(function(article) { return article.id == self.markedRows[0] });

          this.modal.isSaving = true;

          // save/update
          this.entityCreateOrUpdate('socialMediaPost', post)
              .then(function(response) {
                  self.closeModal();
              })

      },

      articleRemove(postId) {

          var post = this.newsletter.data.find((n) => { return n.id == postId });
          post.catalogPageElement = null;
          // this.entityCreateOrUpdate('socialMediaPost', post).then(function(response) {});

      },

      sitePostPublish() {

          var self = this;
          this.isSaving = true;

          // Load the SDK Asynchronously
          (function(d, s, id){
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) {return;}
              js = d.createElement(s); js.id = id;
              js.src = "//connect.facebook.net/en_US/sdk.js";
              fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'facebook-jssdk'));

          if(window.FB) {

              this.fbInit();

          } else {

              window.fbAsyncInit = function() {
                  self.fbInit();
              };

          }

      },

      fbInit() {


          var self = this;

          // find the selectedPost
          var selectedPost = this.sitePosts.find(post => post.id == self.selectedPostId );

          // console.log("selected post: ", selectedPost);
          // console.log("url: ", 'https://www.apothekenkatalog.at/' + selectedPost.catalogPageElement.friendlyName + '?site='+self.siteId);

          FB.init({
              appId: '933884696790336',
              cookie: true,
              status: true,
              xfbml: true,
              version: 'v2.7',
          });

          FB.ui(
          {
              method: 'share',
              href: 'https://www.apothekenkatalog.at/' + selectedPost.catalogPageElement.friendlyName + '?site='+self.siteId,
          },
              function (response) {

                  if(typeof response != 'undefined') {

                      selectedPost.publishDate = new Date();

                      let saveObj = {
                          site: self.siteId,
                          name: selectedPost.name,
                          publishDate: new Date(),
                          catalogPageElement: selectedPost.catalogPageElement.id,
                          socialMediaPost: self.selectedPostId
                      }

                      self.entityCreateOrUpdate('siteSocialMediaPost', saveObj)
                          .then(function(response) {
                              self.isSaving = false;
                          })

                  } else {

                      self.isSaving = false;

                  }

              }
          );
      },

      siteArticleAppend() {

          var self = this;

          this.modal.isSaving = true;
          this.selectedPost.catalogPageElement = this.articles.data.find(function(article) { return article.id == self.markedRows[0] });


          let saveObj = {};

          saveObj.publishDate = this.selectedPost.publishDate;
          saveObj.name = this.selectedPost.name;
          saveObj.catalogPageElement = this.selectedPost.catalogPageElement;

          // we've to deal with a completely new entry
          if(this.selectedPost.isOriginal == true) {
              saveObj.site = this.siteId;
          } else {
              saveObj.id = this.selectedPost.id;
          }

          // save/update
          this.entityCreateOrUpdate('siteSocialMediaPost', saveObj)
              .then(function(response) {
                  self.closeModal();
              })

      },

      sitePostArticleRemove() {

          this.selectedPost.catalogPageElement = null;
          this.$forceUpdate();

      },

      articleSearch() {
          Event.$emit('vue-tables.tbl-socialMediaArticles.filter::search', this.articleSearchString);
      },

      closeModal() {

          // in case we've running an interval
          clearInterval(this.refreshIntervalId);

          Event.$off('vue-tables.tblSocialMedia.row-click');
          Event.$off('vue-tables.tblSocialMediaPharmacies.row-click');

          this.progressStatus = null;

          this.modal.isSaving = false,
          this.showModal = false;
          this.tmpEntry = {
              id: '',
              publishDate: '',
              name: '',
              elements: []
          };
          this.activeRowId = null;
          this.activeRowIndex = null;
          this.markedRows = [];

          this.initEventListeners();
      },

      getNewsletterIndexById(rowId) {

          var newsletterIndex = "";

          for(let i in this.newsletter.data) {
              if(this.newsletter.data[i].id == rowId) {
                  newsletterIndex = i;
                  break;
              }
          }

          return newsletterIndex;

      },

      getImagePath(asset) {

          if(asset != null) {
              return this.$config.assets + asset.path + '/' + asset.filename;
          }
          return "";

      },

      fetchData() {

          this.isLoading = true;

		      var self = this;

          if(this.userRole == 'Administrator') {

              function getCurrentOnlineCatalogName() {
                  return self.axios.get(self.$config.api + 'catalog?filters[isOnline]=1')
              }

              function getPharmacies() {
                  return self.axios.get(self.$config.api + 'site?filters[socialMedia]=1&include=site.socialMediaPosts')
              }

              function getPosts() {
                  return self.axios.get(self.$config.api + 'socialMediaPost?liteCatalogPageElement=1');
              }

              // make the request
              this.axios.all([getCurrentOnlineCatalogName(), getPharmacies(), getPosts()])
                  .then(self.axios.spread(function (currentCatalog, pharmacies, posts) {

                      self.currentCatalogName = currentCatalog.data.catalog[0].displayName;

                      self.newsletter.data = posts.data.socialMediaPost;
                      self.newsletterPharmacies.data = pharmacies.data.site;
                      self.isLoading = false;

                  })).catch(function(error) {
                      self.isLoading = false;
                      console.log('Error: ', error.message);
                  });


          } else {


              function getCurrentOnlineCatalogName() {
                  return self.axios.get(self.$config.api + 'catalog?filters[isOnline]=1')
              }

              function getPosts() {
                  return self.axios.get(self.$config.api + 'socialMediaPost?liteCatalogPageElement=1');
              }

              function getSitePosts() {
                  return self.axios.get(self.$config.api + 'siteSocialMediaPost?liteCatalogPageElement=1&filters[site]='+self.siteId);
              }

              // make the get request
              this.axios.all([getCurrentOnlineCatalogName(), getPosts(), getSitePosts()])

                  .then(self.axios.spread(function (currentCatalog, posts, sitePosts) {

                      self.currentCatalogName = currentCatalog.data.catalog[0].displayName;

                      var currentDate = new Date();
                      var closestDate = Infinity;

                      var postFirstShown = {};
                      var postObj = {};

                      posts.data.socialMediaPost.forEach(function(post) {

                          let postObj = {};
                          // let foundIndex = sitePosts.data.siteSocialMediaPost.findIndex(p => p.id == post.id );
                          let foundIndex = sitePosts.data.siteSocialMediaPost.findIndex(p => p.socialMediaPost == post.id );


                          if(foundIndex > -1) {

                              // console.log("OK");
                              postObj.isOriginal = false;
                              postObj.id = sitePosts.data.siteSocialMediaPost[foundIndex].id;
                              postObj.site = sitePosts.data.siteSocialMediaPost[foundIndex].site;
                              postObj.name = sitePosts.data.siteSocialMediaPost[foundIndex].name;
                              postObj.label = post.name;
                              postObj.catalogPageElement = sitePosts.data.siteSocialMediaPost[foundIndex].catalogPageElement;
                              postObj.scheduleDate = post.scheduleDate;
                              postObj.publishDate = sitePosts.data.siteSocialMediaPost[foundIndex].publishDate;

                          } else {

                              postObj.isOriginal = true;
                              postObj.id = post.id;
                              postObj.site = self.siteId;
                              postObj.name = post.name;
                              postObj.label = post.name;
                              postObj.catalogPageElement = post.catalogPageElement;
                              postObj.scheduleDate = post.scheduleDate;
                              postObj.publishDate = null;

                          }

                          // find the newsletter with the closest date to now
                          // and store it in "newsletterFirstShown"
                          let date = new Date(postObj.scheduleDate);

                          if (date >= currentDate && date < closestDate) {
                              closestDate = date;
                              postFirstShown = postObj;
                          }

                          self.sitePosts.push(postObj);

                      });

                      if(typeof postFirstShown.publishDate == 'undefined') {
                          postFirstShown = self.sitePosts[0];
                      }

                      self.selectedPostId = postFirstShown.id;

                      self.changedPost = {
                          id: postFirstShown.id,
                          scheduleDate: postFirstShown.scheduleDate,
                          name: postFirstShown.label,
                      }

                      self.isLoading = false;


                  })).catch(function(error) {
                      self.isLoading = false;
                      console.log('Error: ', error.message);
                  });


          }


      },

      sitePostArticlesLoad() {

          this.modal.title = "Artikel";
          this.modal.type = "sitePosts";
          this.modal.class = 'tbl-socialMediaArticles vcenter';
          this.modal.width = '860';
          this.modal.isLoading = true;
          this.showModal = true;

          var self = this;

          this.axios.get(this.$config.api + 'catalogPageElement/onlineCatalogArticles')
              .then((response) => {

                  self.articles.data =  response.data;
                  self.modal.isLoading = false;

                  Event.$on('vue-tables.tblSocialMediaArticles.row-click', function(data) {

                      if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                          return false;
                      }

                      let foundIndex = self.markedRows.findIndex(function(row) { return row == data.row.id; });

                      if(foundIndex > -1) {
                          self.markedRows.splice(foundIndex, 1);
                      } else {
                          self.markedRows.push(data.row.id);
                      }

                  });

          });

      },

      articlesLoad(rowId) {

          var self = this;

          this.activeRowId = rowId;
          this.modal.title = "Artikel";
          this.modal.type = "articles";
          this.modal.class = 'tbl-socialMediaArticles vcenter';
          this.modal.width = '860';
          this.modal.isLoading = true;
          this.showModal = true;

          this.axios.get(this.$config.api + 'catalogPageElement/onlineCatalogArticles').then(function(response) {

              self.articles.data =  response.data;
              self.modal.isLoading = false;

              Event.$on('vue-tables.tblSocialMediaArticles.row-click', function(data) {

                  if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                      return false;
                  }

                  let foundIndex = self.markedRows.findIndex(function(row) { return row == data.row.id; });

                  if(foundIndex > -1) {
                      self.markedRows.splice(foundIndex, 1);
                  } else {
                      self.markedRows.push(data.row.id);
                  }

              });

          });
      },

    }
}
</script>


<style lang="scss">
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    .p-default {
        margin: 0;
    }
</style>

<style>
    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: 0 auto;
        text-align: center;
    }
    .VueTables__child-row-toggler--closed::before {
        font-family: 'aki';
        content: '\e92c';
        display: inline-block;
        width: 12px;
    }
    .VueTables__child-row-toggler--open::before {
        font-family: 'aki';
        content: '\e911';
        display: inline-block;
        width: 12px;
    }

    .preview a.readmore {
        background: none !important;
        display: inline !important;
        text-decoration: underline !important;
        font-weight: normal !important;
        border: none !important;
        text-transform: lowercase !important;
    }
</style>


<style scoped>

    .newsletterHeader .scheduleDate {
        text-transform: uppercase;
        font-size: 11px;
    }
    h2 {
        font-size: 1.3rem;
        margin-bottom: 25px;
    }

    .centered {
        max-width: 700px;
        margin: 0 auto;
    }
    .centered >>> .control > .control {
        max-width: 100%;
    }
    .centered .newsletterArticles {
        margin: 0 auto;
        width: 100%;
    }
    .centered >>> .columns.newsletterArticle {
        max-width: 100%;
        margin: 0;
        white-space: normal;
        border-bottom: 1px solid #eee;
        padding-bottom: 6px;
        margin-bottom: 6px;
    }
    .centered >>> .columns.newsletterArticle:last-child {
        border-bottom: none !important;
        margin-bottom: 0;
    }
    .centered >>> .columns.newsletterArticle span.delArticle {
        visibility: hidden;
        opacity:0;
        transition: opacity 0.5s ease;
    }
    .centered >>> .columns.newsletterArticle:hover span.delArticle:not(.is-disabled) {
        visibility: visible;
        opacity:1;
    }

    .centered >>> .columns.newsletterArticle:last-child {
        margin-bottom: 0;
    }
    .centered >>> .columns.newsletterArticle .column {
        padding: 10px 5px;
        line-height: 1.2rem;
    }
    .centered >>> .columns.newsletterArticle .column:first-child {
        padding-left: 0;
    }
    .centered >>> .columns.newsletterArticle .column:last-child {
        padding-right: 0;
    }
    .centered >>> .columns.newsletterArticle .imgWrapper {
        width: 200px;
        height: 130px;
        margin: 0 5px 0 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }

    .centered >>> .columns.newsletterArticle .column .headline {
        display: block;
        /*font-weight: bold;*/
        margin-top: 5px;
        margin-bottom: 10px;
        font-size: 1.2rem;
    }

    .hrLine {
        padding-top: 12px;
        border-bottom: 1px solid #EEE;
        margin: 0 -20px 12px -20px;
    }


    /* pharmacies table */
    .tbl-socialMediaPharmacies >>> .status > td:first-child {
        position: relative;
    }
    .tbl-socialMediaPharmacies >>> .status > td:first-child::after {
        background: transparent;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 5px;
    }

    .tbl-socialMediaPharmacies >>> .status.SENT > td:first-child::after {
        background-color: #84ED51;
    }


    .tbl-socialMediaPharmacies >>> .VueTables__table th:nth-child(2) {
        width: 180px;
    }
    .tbl-socialMedia >>> .VueTables__table tbody tr:not(:last-child) td {
        border-bottom: 1px solid #ddd !important;
    }
    .tbl-socialMedia >>> .VueTables__table th:first-child {
        width: 20px;
        max-width: 20px;
    }
    .tbl-socialMedia >>> .VueTables__table th:nth-child(2) {
    }
    .tbl-socialMedia >>> .VueTables__table th:nth-child(3) {
        max-width: 150px;
        width: 150px;
    }


    .tbl-socialMedia >>> .VueTables__table td:first-child {
        position: relative;
    }
    .tbl-socialMedia >>> .VueTables__table tr:not(.VueTables__child-row) td:last-child {
        text-align: right;
    }
    .tbl-socialMedia >>> .VueTables__table tr:not(.VueTables__child-row) td:first-child {
        padding: 0;
    }
    .tbl-socialMedia >>> .VueTables__table tr:not(.VueTables__child-row) td:first-child span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
    }

    .tbl-socialMedia >>> .VueTables__table tr.VueTables__child-row td {
        cursor: default;
    }
    .tbl-socialMedia >>> .VueTables__table tr.VueTables__child-row:hover {
        background: none !important;
    }

    .columns.articles {
        max-width: 640px;
        padding: 2px;
        margin: 0 0 0 0;
    }
    .columns.articles .column {
        padding: 0 5px;
        margin: 0;
        display: flex;
        align-items: center;
        white-space: initial;
        line-height: 1.2rem;
    }
    .columns.articles .column .headline {
        font-weight: 500;
        display: block;
        margin-bottom: 5px;
    }
    .columns.articles:last-child {
        margin: 0;
        background: transparent;
    }




    /* articles modal */
    >>> .modal-card-body {
        overflow: auto;
    }
    .tbl-socialMediaArticles >>> td {
        padding: 5px 8px;
    }
    .tbl-socialMedia >>> th:first-child {
        width: 35px;
    }
    .tbl-socialMediaArticles >>> th:first-child {
        width: 40px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 4px;
    }
    .tbl-socialMediaArticles >>> th:nth-child(2) {
        width: 70px;
    }

    .tbl-socialMediaArticles >>> td:first-child {
        position: relative;
        width: 35px;
    }
    .tbl-socialMediaArticles >>> td:first-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
    .tbl-socialMediaArticles >>> td:nth-child(2) .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 70px;
		height: 50px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.tbl-socialMediaArticles >>> td:nth-child(2) .imgWrapper[lazy=loading] {
		background-size: 30% !important;
	}
    .tbl-socialMediaArticles >>> td:nth-child(2) .imgWrapper[lazy=error] {
		background-size: contain !important;
	}


    /* pharmacies */
    .tbl-socialMediaPharmacies >>> th:first-child {
        width: 35px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 4px;
    }
    .tbl-socialMediaPharmacies >>> td:first-child {
        position: relative;
        width: 35px;
    }
    .tbl-socialMediaPharmacies >>> td:first-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
</style>

<style lang="scss">


    .socialMedia {

        .imgWrapper {
            background-repeat: no-repeat;
            background-position: 50% 50% !important;
            background-size: cover;
            width: 85px;
            height: 65px;
            margin: 0;
            background-color: #FFF;
            border: 1px solid #efefef;
            border-radius: 2px;
        }
        .imgWrapper[lazy=loading]  {
            background-size: 30% !important;
        }
        .imgWrapper[lazy=error]  {
            background-size: contain !Important;
        }

        .imgWrapper.plain {
            background-image: none !important;
            display: flex;
            justify-content: center;
            align-items: center;
        }

    }

</style>
